import { useContext } from 'react';
import { Spinner, PageHeader } from 'components';
import { colors, Grid } from '@material-ui/core';
import { Queues, Filters, Toolbar, Results, TicketsDashboard } from './components';
import { ticketsContext } from './TicketsContext';
import { applicationContext, appUserContext } from 'helpers/services';
import { UserType, TicketQueue } from 'helpers/enums';

let Tickets = () => {
    let { currentUser } = useContext(appUserContext);
    let { ticketQueues } = useContext(applicationContext);
    let { isLoading, queue } = useContext(ticketsContext);

    return (
        <Grid container>
            {currentUser?.typology === UserType.VitecUser &&
                <Grid item xs={4} sm={3} md={2} style={{ borderRight: `1px solid ${colors.grey[300]}` }}>
                    <Queues />
                </Grid>
            }
            <Grid item xs={8} sm={9} md={10}>
                {isLoading && <Spinner />}
                {isLoading === false &&
                    <>
                        <PageHeader
                            title={ticketQueues.getValueByKey(queue) || 'Tickets'}
                            addNewUrl={currentUser?.canCreateTickets ? "/ticket/addnew" : ''}
                        />

                        {queue === TicketQueue.TicketsDashboard && <TicketsDashboard />}
                        {queue !== TicketQueue.TicketsDashboard &&
                            <>
                                <Filters />
                                <Toolbar />
                                <Results />
                            </>
                        }
                    </>
                }
            </Grid>
        </Grid>
    )
}

export default Tickets;